
import Restful from "@/services/RestFul";
export default {
    data: () => ({
        pharmaNotify: 0
    }),
    created() { this.pharmaClients(); },
    watch: {},
    methods: {
        pharmaClients() {
            console.log('called')
            Restful.medics.treatment.transact.prospect.prescribe
                .client(false)
                .then((response) => {
                    // console.log(response.data.length);
                    if (response.status === 200) {
                        this.pharmaNotify = response.data.length;
                    } else {
                        this.pharmaNotify = 0;
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                });

        }
    }
}